import { FeatureBase } from '../FeatureBase'

// 扩展功能注册表
declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    pairing: IPairingFeature
  }
}

export interface IPairingFeature {
  // 开始配对
  start(): Promise<boolean>
  // 退出配对模式
  exit(): Promise<void>
}

export class pairingFeature extends FeatureBase implements IPairingFeature {
  start(): Promise<boolean> {
    return this.unsupported('pairingFeature.start')
  }

  exit(): Promise<void> {
    return this.unsupported('pairingFeature.exit')
  }
}
